// extracted by css-extract-rspack-plugin
var _1 = "_-8tti24Z384EIJ2Tx-zskg--";
var _2 = "NjZhUhhWIGNRqtSiQLVsPQ--";
export { _1 as "label", _2 as "ratingList" }
